import { render } from "./termOfValidity.vue?vue&type=template&id=029c74a0&scoped=true"
import script from "./termOfValidity.vue?vue&type=script&lang=js"
export * from "./termOfValidity.vue?vue&type=script&lang=js"

import "./termOfValidity.vue?vue&type=style&index=0&id=029c74a0&scoped=true&lang=css"
import "./termOfValidity.vue?vue&type=style&index=1&id=029c74a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-029c74a0"

export default script